exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.svg-icon[data-v-9e2f8540] {\n  display: inline-block;\n  cursor: pointer;\n  text-align: center;\n}\n.custom-icon[data-v-9e2f8540] {\n  vertical-align: middle;\n  fill: currentColor;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
